<template>
	<v-card
		width="85%"
		class="py-4"
	>
		<div class="text-center card-label">
			{{ cardLabel }}
		</div>
		<div
			v-if="previousScan"
			class="text-center mt-3 card-value"
		>
			<p>
				Current Scan - {{ currentScan }}
			</p>
			<p>
				Previous Scan - {{ previousScan }}
			</p>
		</div>
		<div v-else>
			<div class="text-center mt-3 card-value">
				{{ currentScan }}
			</div>
		</div>
	</v-card>
</template>

<script>
export default {
	props: {
		previousScan: { type: [String, Number], default: null },
		currentScan: { type: [String, Number], required: true },
		cardLabel: { type: String, required: true }
	}
}
</script>

<style scoped>
.card-label {
	font-size: 1.5rem;
	font-weight: 500;
	color: var(--global-foreground);
}

.card-value {
	font-size: 1.25rem;
	font-weight: 400;
	color: var(--global-muted-foreground);
}
</style>
